
import { useState, useEffect, lazy, Suspense } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import UrgentServices from './components/UrgentServices';
import Services from './components/Services';
import ServiceAreas from './components/ServiceAreas';
import Testimonials from './components/Testimonials';
import WhyChooseUs from './components/WhyChooseUs';
import Footer from './components/Footer';
import QuoteForm from './components/QuoteForm';

// Only lazy load non-critical floating widgets
const FloatingWhatsApp = lazy(() => import('./components/FloatingWhatsApp'));
const FloatingAI = lazy(() => import('./components/FloatingAI'));

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <HeroSection />
      <UrgentServices />
      
      <Services />
      <div id="avaliacoes">
        <Testimonials />
      </div>
      <WhyChooseUs />
      
      {/* Form at the end of the page */}
      <section className="py-16 bg-gray-50" id="orcamento">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-2xl p-8">
            <QuoteForm />
          </div>
        </div>
      </section>
      
      {/* Zonas Atendidas */}
      <div id="zonas">
        <ServiceAreas />
      </div>
      
      <Suspense fallback={null}>
        <FloatingAI />
        <FloatingWhatsApp />
      </Suspense>
      <Footer />
    </div>
  );
};

export default HomePage;
